import styles from './styles.module.scss';
import { useMemo } from 'react';
import { trenballColors } from '@/constants/trenball-colors';
import TrendPopupContentTrendGridSkeleton from './Skeleton';
import { TrendPopupContentTrendGridProps } from './props';
import { ErrorCard } from '@starsoft/common/components';

export default function TrendPopupContentTrendGrid({
  data,
  error,
  isLoading,
  refetch,
}: TrendPopupContentTrendGridProps) {
  const Grid = useMemo(
    () =>
      data?.map((row, colIdx) => (
        <div
          className={styles.container__column}
          key={`trend_grid_column_${colIdx}`}
        >
          {row.map((color, rowIndex) => (
            <div
              className={styles.container__column__cell}
              key={`trend_grid_cell_${rowIndex}`}
            >
              <div
                className={styles.container__column__cell__dot}
                style={{
                  backgroundColor: color
                    ? trenballColors.get(color)
                    : undefined,
                }}
              />
            </div>
          ))}
        </div>
      )),
    [data],
  );

  if (error) {
    return <ErrorCard error={error} refetch={() => refetch?.()} />;
  }

  if (isLoading) {
    return <TrendPopupContentTrendGridSkeleton />;
  }

  return <div className={styles.container}>{Grid}</div>;
}
